<div class="container">
    <div class="modal-wrapper">
        <h1>{{ "language_selection.subtitle" | translate }}</h1>
        <span>{{ "language_selection.description" | translate }}</span>

        <div class="select-button-wrapper">
            <ion-radio-group
                [value]="selectedLanguage?.id"
                (ionChange)="onLanguageChange($event)"
            >
                <ion-item
                    *ngFor="let language of availableLanguages; let i = index"
                    class="option"
                    [class.option-selected]="isSelected(language)"
                >
                    <ion-radio slot="start" [value]="language.id"></ion-radio>
                    <ion-label class="label">
                        {{ language.name }}
                    </ion-label>
                </ion-item>
            </ion-radio-group>
        </div>

        <div class="confirm-btn-wrapper">
            <ion-button
                [disabled]="!selectedLanguage || isLoading"
                (click)="confirmSelection()"
                class="confirm-btn"
                expand="full"
            >
                <ion-spinner
                    *ngIf="isLoading"
                    name="crescent"
                    class="spinner"
                ></ion-spinner>
                <span *ngIf="!isLoading">
                    {{ "language_selection.confirm" | translate }}
                </span>
            </ion-button>
        </div>
    </div>
</div>
